import { removeInitialContent } from "@escapio/shared/components/element-builder";
import { html, render } from "lit-html";
import unsaferHTML from "@escapio/shared/unsaferHTML";
import connect from "../../../shared/data-store/connect";
import { store } from "./DataStore";

customElements.define(
	"esc-hotel-list-header-counter",
	class extends connect(removeInitialContent(HTMLElement), store) {
		update(state, { counters }) {
			const count = counters.unfiltered;
			const renderedCount = `<strong>${count}</strong>`;
			const headline =
				count === 1
					? this.getAttribute("translation-singular")
					: this.getAttribute("translation-plural");

			const template = html`
				${unsaferHTML(headline.replace("%Hotelanzahl%", renderedCount))}
			`;
			render(template, this);
		}
	},
);
